import React, { useCallback } from 'react';
import { Flex, Divider } from '@televet/kibble-ui/build/chakra';
import SendHours from './SendHours';
import SurveyFrequency from './SendFrequency';
import LinkToReview from './LinkToReview';
import AutomationSettings from './SurveySettings';
import { useSurveySettingsContext, ISurveyGeneralSettings } from 'pages/Survey/context/SurveySettingsContext';
import { AutomationSettingsSkeleton, GeneralSettingsSkeleton } from './SettingsSkeleton';
import { SurveySettingsActions } from 'pages/Survey/context/SurveySettingsReducer';
import StatusChange from './StatusChange';
import { useTracking } from 'shared/providers/TrackingProvider';
import { SurveyEvents } from 'shared/providers/TrackingProvider/EventNames';

const SurveySettings = (): JSX.Element => {
  const { isLoading, dispatch, generalSettings, composeSettings, surveySettingId } = useSurveySettingsContext();
  const { trackEvent } = useTracking();

  const handleChange = useCallback(
    (field: keyof ISurveyGeneralSettings | 'sentStatusId', newValue: string | boolean | number) => {
      if (field === 'sentStatusId') {
        // sent status change is actually saved on rating workflow
        dispatch({
          type: SurveySettingsActions.UPDATE_COMPOSE_SETTINGS,
          payload: { ...composeSettings, [field]: newValue },
        });
        dispatch({ type: SurveySettingsActions.SET_RATING_WORKFLOW_CHANGED, payload: true });
        trackEvent(SurveyEvents.EditSurveySendStatusChange, { message: newValue });
      } else {
        dispatch({
          type: SurveySettingsActions.UPDATE_GENERAL_SETTINGS,
          payload: { ...generalSettings, [field]: newValue },
        });
        dispatch({ type: SurveySettingsActions.SET_SURVEY_SETTING_CHANGED, payload: true });
        trackEvent(SurveyEvents.SurveySettingsUpdated, { field, message: newValue });
      }
    },
    [dispatch, composeSettings, trackEvent, generalSettings],
  );

  return (
    <Flex className="settings" width={600} direction="column" p="20px 0">
      {isLoading && !surveySettingId ? (
        <AutomationSettingsSkeleton />
      ) : (
        <AutomationSettings handleChange={handleChange} />
      )}
      {isLoading && !surveySettingId ? (
        <GeneralSettingsSkeleton />
      ) : (
        <>
          <Divider mt="40px" />
          <SendHours />
          <SurveyFrequency handleChange={handleChange} />
          <StatusChange handleChange={handleChange} />
          <Divider mt="40px" />
          <LinkToReview handleChange={handleChange} />
        </>
      )}
    </Flex>
  );
};

export default SurveySettings;
